import News from './News'
import './News.css'

export default News



// WEBPACK FOOTER //
// ./src/features/RestaurantAndCafe/containers/News/index.js